import { __assign } from 'tslib';
import clsx from 'clsx';
import Vue from 'vue';
import __vue_component__ from '../HseTag/HseTag.vue.js';

var script = Vue.extend({
    name: 'HseSelectTag',
    functional: true,
    render: function (h, ctx) {
        var _a;
        var listeners = ctx.listeners, data = ctx.data, children = ctx.children;
        return h(__vue_component__, __assign(__assign({}, data), { staticClass: clsx('hse-Select__multipleValue', {
                'hse-Select__multipleValue_disabled': (_a = data.attrs) === null || _a === void 0 ? void 0 : _a.disabled
            }, data.staticClass), on: listeners }), children);
    }
});

export default script;
